import { createFileRoute } from '@tanstack/react-router'
import { MembershipTypesCard } from '@/features/membership-types/components/membership-types-card'

export const Route = createFileRoute(
  '/_authenticated/memberships/manage-types'
)({
  component: MembershipsManageTypesView,
})

function MembershipsManageTypesView() {
  return <MembershipTypesCard />
}
